import client from "./client";

const getTransactionsSummary = (currency = "NGN") =>
  client.get("metric/transaction/summary?currency=" + currency);

export default { getTransactionsSummary };
